import React from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Switch,
    Redirect
} from 'react-router-dom';
import routes from 'routes/';
import { Provider } from 'react-redux';
import store from 'stores/stores/index';
import ProtectedRoute from 'components/shared/atoms/ProtectedRoute/ProtectedRoute';
// Styles
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-awesome-lightbox/build/style.css";
// Custom Styles (after bootstrap to overwrite any style)
import 'assets/styles/global.scss';
// Amplify AWS to authenticate
import Amplify from 'aws-amplify';
import config from 'config/config';
import * as atatus from 'atatus-spa';
import { ErrorBoundary } from 'react-error-boundary';
import { logErrorToAtatus } from 'services/atatus';
import * as moment from 'moment-timezone';

Amplify.configure(
    {
        Auth: {
            // REQUIRED - Amazon Cognito Region
            region: process.env.REACT_APP_AWS_REGION,
            // OPTIONAL - Amazon Cognito User Pool ID
            userPoolId: process.env.REACT_APP_AWS_USER_POOL_ID, // VP-UAT
            // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'
            authenticationFlowType: process.env.REACT_APP_AUTHENTICATION_FLOW_TYPE,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEB_CLIENT_ID
        }
    }
);

// Initialize atatus to monitor the application for staging and production only
if (process.env.REACT_APP_STAGE === 'staging' || process.env.REACT_APP_STAGE === 'production') {
    atatus.config(config.ATATUS.KEY).install();
}

// Clean path in the stack trace
if (atatus) {
    atatus.onBeforeErrorSend(function (payload) {
        var backTraces = payload.backTraces;
        for(var i = 0 ; i < backTraces.length; i++) {
            var backTrace = backTraces[i];
            var filename = backTrace.f;
            var indexOfJsRoot = filename.indexOf("/www/");
            if (indexOfJsRoot !== -1) {
              backTrace.f = filename.substring(indexOfJsRoot);
            }
        }
        return true;
    });
}

// We must set the default timezone so that the user timezone will be offset correctly
moment.tz.setDefault('Etc/UTC');

ReactDOM.render(
    <ErrorBoundary onError={(error, info) => {
        logErrorToAtatus(error, info);
    }}>
        <Provider store={store}>
            <Router>
                <Switch>
                    <Redirect from="/" to="/login" exact />
                    {routes.map((route, index) => <ProtectedRoute key={index} {...route} />)}
                </Switch>
            </Router>
        </Provider>
    </ErrorBoundary>,
    document.getElementById('root')
);
